import * as yup from 'yup';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import toObject from 'dayjs/plugin/toObject';
import { t } from 'i18next';

dayjs.extend(utc);
dayjs.extend(toObject);

export const validationObject = object => yup.object().shape(object);

export const validateRequired = () =>
  yup
    .string()
    .nullable()
    .required('required_label');
/* eslint-disable  no-invalid-this*/
export const validateStringNotEmpty = () =>
  yup
    .string()
    .test('check if name string is empty', function getThisObject(name) {
      const { path, createError } = this;
      if (!name) return true;
      if (name.length === 0) {
        return createError({
          path,
          message: 'required_label',
        });
      } else if (name.length > 50) {
        return createError({
          path,
          message: 'Cannot be more than 50 characters',
        });
      }
      return true;
    })
    .required('required_label');

export const validateString = (maxLength, required) =>
  required
    ? yup
        .string()
        .required('required_label')
        .max(
          maxLength,
          `The maximum length allowed is ${maxLength} character(s).`,
        )
    : yup
        .string()
        .max(
          maxLength,
          `The maximum length allowed is ${maxLength} character(s).`,
        );

export const validateId = ({ maxLength, required, allowedNull }) => {
  if (required && allowedNull) {
    yup
      .string()
      .required('required_label')
      .max(
        maxLength,
        `The maximum length allowed is ${maxLength} character(s).`,
      )
      .nullable();
  } else if (required) {
    yup
      .string()
      .required('required_label')
      .max(
        maxLength,
        `The maximum length allowed is ${maxLength} character(s).`,
      );
  } else if (allowedNull) {
    yup
      .string()
      .nullable()
      .max(
        maxLength,
        `The maximum length allowed is ${maxLength} character(s).`,
      );
  } else {
    yup
      .string()
      .max(
        maxLength,
        `The maximum length allowed is ${maxLength} character(s).`,
      );
  }
};

export const validateMessagingTitleString = maxLength =>
  yup.string().test('check-if-re-fw-exists', function getThisObject(title) {
    //Keep in mind that ES6 arrow function syntax cannot be used here
    //as it retains the [this] from the enclosing lexical context.
    //You won’t be able to access methods in this object

    const { path, createError } = this;

    if (!title) return true;
    const reFwExists =
      title.toUpperCase().startsWith('RE:') ||
      title.toUpperCase().startsWith('FW:');

    if (reFwExists) {
      // replace re or Fw
      if (title.toUpperCase().startsWith('RE:')) {
        if (title.length > maxLength) {
          return createError({
            path,
            message: `The maximum length allowed is 50 characters.`,
          });
        } else return true;
      }
      if (title.toUpperCase().startsWith('FW:')) {
        if (title.length > maxLength) {
          return createError({
            path,
            message: `The maximum length allowed is 50 characters.`,
          });
        } else return true;
      }
    } else if (title.length > 50) {
      return createError({
        path,
        message: `The maximum length allowed is 50 characters.`,
      });
    }
    return true;
  });

export const validateArrayRequired = () =>
  yup
    .array()
    .min(1, 'required_label')
    .required('required_label');
export const validatePositiveInteger = (required = true) =>
  required
    ? yup
        .string()
        .matches(/^[0-9]*$/, 'Value can only contains digits')
        .required('Value is required')
    : yup.string().matches(/^[0-9]*$/, 'Value can only contains digits');

export const validateName = (maxLength, required = true) =>
  required
    ? yup
        .string()
        .max(
          maxLength,
          `The maximum length allowed is ${maxLength} character(s).`,
        )
        .required('required_label')
    : yup
        .string()
        .max(
          maxLength,
          `The maximum length allowed is ${maxLength} character(s).`,
        );

export const validateMaxLength = maxLength =>
  yup
    .string()
    .max(maxLength, `The maximum length allowed is ${maxLength} character(s).`);

export const validateDuration = (required, maxLength) =>
  required
    ? yup
        .string()
        .matches(/^[0-9]*$/, `Duration can only contains digits`)
        .max(maxLength, `Duration cannot contain more than 6 digits.`)
        .required(`Duration  is required`)
    : yup
        .string()
        .matches(/^[0-9]*$/, `Duration  can only contains digits`)
        .max(maxLength, `Duration  cannot contain more than 6 digits.`);

export const validatePassCode = (required, minLength, maxLength) =>
  required
    ? yup
        .string()
        .min(minLength, `Passcodes must contain at least ${minLength} digits.`)
        .matches(/^[0-9]*$/, 'Passcodes can only contains digits')
        .max(maxLength, 'Passcodes cannot contain more than 6 digits.')
        .required('Passcode is required')
    : yup
        .string()
        .min(minLength, `Passcodes must contain at least ${minLength} digits.`)
        .matches(/^[0-9]*$/, 'Passcodes can only contains digits')
        .max(maxLength, 'Passcodes cannot contain more than 6 digits.');
export const validateEmail = required =>
  required
    ? yup
        .string()
        .email('Email is invalid')
        .required('Email is required')
        .max(320, `The maximum length allowed is 320 characters.`)
    : yup
        .string()
        .email('Email is invalid')
        .max(320, 'The maximum length allowed is 320 characters');

export const validatePhoneNumber = () =>
  yup
    .string()
    .min(1, 'Phone numbers must contain at least 1 digit.')
    .matches(/^[0-9-( )]+$/, 'Phone numbers can only contains digits.') //Regex should allow only numeric, white spaces and hyphen
    .max(30, `Phone numbers cannot contain more than 30 digits`);
export const validateRequiredPhoneNumber = () =>
  yup
    .string()
    .min(1, 'Phone numbers must contain at least 1 digit.')
    .matches(/^[0-9-( )]+$/, 'Phone numbers can only contains digits.') //Regex should allow only numeric, white spaces and hyphen
    .max(30, `Phone numbers cannot contain more than 30 digits`)
    .required('required_label');
export const validateArrayRequirement = min =>
  yup
    .array()
    .min(min, `The list must contain at least ${min} point(s).`)
    .required('required_label');
export const validateRange = (min, max, currencySymbol) =>
  yup
    .number()
    .moreThan(
      min - 1,
      `The minimum allowable price is ${currencySymbol}${min}.`,
    )
    .lessThan(
      max + 1,
      `The maximum allowable price is ${currencySymbol}${max}.`,
    )
    .required('required_label');

export const validateConditionalRequired = ({ conditionKey, conditionValue }) =>
  yup
    .string()
    .required('required_label')
    .min(1)
    // server sends site value as null when multisite is true
    /// if not set, this creates problem with schema as strings are not nulls
    .nullable(true)
    .when(conditionKey, {
      is: conditionValue,
      then: validateRequired(),
    });

// This only works when there is formik key which is same as conditionKey available when the form renders
// Make sure that conditionKey is set in the initial values of the form
export const validateConditionallyIfRequired = ({
  conditionKey,
  conditionValue,
}) =>
  yup
    .string()
    .when(conditionKey, { is: conditionValue, then: validateRequired() });

export const validateEndDate = (minDate, required) => {
  return required
    ? yup
        .date()
        .min(
          minDate,
          'Invalid Date. Please select a time later than start time.',
        )
        .required('required_label')
    : yup
        .date()
        .min(
          minDate,
          'Invalid Date. Please select a time later than start time.',
        );
};

export const validateDateRequired = () =>
  yup
    .date()
    .nullable()
    .required('required_label');

export const validateStartDate = () => {
  return {
    startAfter: yup.date().required('required_label'),
    finishBefore: yup
      .date()
      .min(
        yup.ref('startAfter'),
        "End date and time can't be before Start date",
      )
      .nullable(),
  };
};

export const validateLastActivity = ({ lastActivity, currentActivity }) => {
  if (!currentActivity) {
    return true;
  }
  // converting to a unix timestamp makes it easier to compare two date times
  const lastActivityTimestamp = dayjs(lastActivity)
    .toDate()
    .getTime();

  const currentActivityTimestamp = dayjs(currentActivity)
    .toDate()
    .getTime();

  const todayTimeStamp = new Date().getTime();

  // You can only set date time greater than lastActivityTimestamp and less than now datetime stamp
  const currentActivityTimestampAfter =
    currentActivityTimestamp >= todayTimeStamp;

  const currentActivityTimestampBefore =
    currentActivityTimestamp <= lastActivityTimestamp;

  return {
    activityTime: yup
      .string()
      .test(
        'testdate time',
        'Select right activityDateTime',
        function getThisObject() {
          const { path, createError } = this;
          if (currentActivityTimestampBefore) {
            return createError({
              path,
              message: t('Time must be after last activity'),
            });
          } else if (currentActivityTimestampAfter) {
            return createError({
              path,
              message: t('Time must be before now'),
            });
          } else {
            return true;
          }
        },
      )
      .required('required_label'),
  };
};

// return required
//   ? yup
//       .date()
//       .when(
//         key,
//         (startDate, schema) =>
//           startDate &&
//           schema.max(
//             yup.ref(key),
//             'Invalid start time. It is after the finish time.',
//           ),
//       )
//       .required('required_label')
//       .nullable(false)
//   : yup.date().when(key, {
//       is: value => !isEmpty(value),
//       then: () =>
//         yup
//           .date()
//           .max(
//             yup.ref(key),
//             'Invalid start time. It is after the finish time.',
//           ),
//     });
